<template>
    <div>
		<el-card shadow="never">
			<el-row :gutter="10">
				<el-col :span="24">
					<div style="display: flex;justify-content: flex-end;align-items: center;">
                        <el-button
                            type="primary" 
                            @click="init()"
                            icon="el-icon-refresh"></el-button>
                    </div>
				</el-col>
			</el-row>
			<el-table :data="ListData" v-loading="loading.sch" :height="BoxHeight" border>
			    <el-table-column label="联系号码" prop="UserPhoneNum">
					<template slot-scope="scope">
						<div class="ReSeq">{{ scope.row.UserPhoneNum }}</div>
					</template>
				</el-table-column>
				<el-table-column label="充值金额" prop="SubsidyAmount">
					<template slot-scope="scope">
						<div class="ReSeq" v-if="scope.row.SubsidyAmount===0">0 元</div>
						<div class="ReSeq" v-else-if="scope.row.SubsidyAmount>0">
							+{{scope.row.SubsidyAmount}} 元
						</div>
						<div class="ReSeq" v-else>{{scope.row.SubsidyAmount}} 元</div>
					</template>
				</el-table-column>
				<el-table-column label="修改人姓名" prop="Name">
					<template slot-scope="scope">
						<div class="ReSeq">{{ scope.row.Name }}</div>
					</template>
				</el-table-column>
				<el-table-column label="充值前金额" prop="SubsidyBalance">
					<template slot-scope="scope">
						<div class="ReSeq">{{ scope.row.SubsidyBalance / 100 }} 元</div>
					</template>
				</el-table-column>
				<el-table-column label="充值后金额" prop="Balance">
					<template slot-scope="scope">
						<div class="ReSeq">{{ scope.row.Balance / 100 }} 元</div>
					</template>
				</el-table-column>
				<el-table-column label="充值时间" prop="ModifyTime">
					<template slot-scope="scope">
						<div class="ReSeq">{{ scope.row.ModifyTime }}</div>
					</template>
				</el-table-column>
				<el-table-column label="备注" prop="Reason">
					<template slot-scope="scope">
						<div class="ReSeq">{{ scope.row.Reason }}</div>
					</template>
				</el-table-column>
			</el-table>
			<el-pagination
				background
				layout="prev, pager, next"
				prev-text="上一页"
				next-text="下一页"
				@current-change="PrevChange"
				:current-page="SchParam.PageNo"
				:page-count="SchParam.PageCount">
			</el-pagination>
		</el-card>
	</div>
</template>

<script>
import { MessageBox, Message, Loading } from 'element-ui';
import MerchantLog from './MerchantLog.js'
export default {
	name:'MerchantLog',
	created(){
		this.getHeight();
		this.init()
		window.addEventListener("resize", this.getHeight);
	},
	destroyed() {
	    window.removeEventListener("resize", this.getHeight);
	},
	data(){
		return {
			BoxHeight:768,
			ListData:[],
			SchParam:{
				PageNo:1,  //查询页码；
				PageSize:15, //每页数量；
				PageCount:0,//页码总数；
				ItemSize:0,//记录总数；
    		},
			loading: {
				sch: false
			}
		}
	},
	methods:{
		async init(){
			this.ListData = [];
            this.SchParam = {
				PageNo:1,  //查询页码；
				PageSize:15, //每页数量；
				PageCount:0,//页码总数；
				ItemSize:0,//记录总数；
    		}
			this.loading.sch = true;
			const res = await MerchantLog.SeeMemberLog(this.SchParam.PageNo, this.SchParam.PageSize);
			if(res){
				if(res.SuccStat===0){
					this.ListData           = res.Infos;
					this.SchParam.PageCount = res.PageCount;
					this.SchParam.ItemSize  = res.ItemSize;
				}
				else{
					Message.error('查询失败');
					this.SchParam.PageCount = 0;
					this.SchParam.ItemSize  = 0;
				}
			}
			this.loading.sch = false;
		},
		//分页
  		PrevChange(val) {
            this.SchParam.PageNo = val;
            this.ListData = [];
            this.init();
        },
		//动态设置页面高度；
		getHeight() {
			this.BoxHeight = window.innerHeight-238;
    	}
	}
}
</script>

<style lang="scss" scoped>	
.el-table{
	margin-top:10px;
	font-size:13px;
}
.el-pagination{
	text-align:center;
	margin-top:10px;
}
.ReSeq{
	width:100%;
	overflow: hidden;
	text-overflow: ellipsis;
	white-space: nowrap;
}
.ReSeq:hover{
	text-overflow:inherit; 
    overflow: visible; 
    white-space: pre-line;
}
</style>
